import { DatePicker } from '../src/DatePicker';
export default DatePicker;
